import { F0AiBanner } from '@factorialco/f0-react/dist/experimental'
import { AtsAiSummaryFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  data: AtsAiSummaryFragment
}

export const CandidateAIHighlights = ({ data }: Props) => {
  const parsedDetails = JSON.parse(data.details)
  const highlights = Array.isArray(parsedDetails.highlights) ? parsedDetails.highlights : []

  const highlightsHtml =
    highlights.length > 0
      ? `<ul>${highlights.map((highlight: string) => `<li>${highlight}</li>`).join('')}</ul>`
      : ''

  return highlightsHtml ? (
    <F0AiBanner title={i18n.t('ats.candidate_details.ai_summary_title')} content={highlightsHtml} />
  ) : null
}
